export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text)
        if (!response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
                // TODO auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                window.location.reload(true)
            }
            const error = (data && data.message) || response.statusText
            return Promise.reject(error)
        }

        return data
    })
}

export function getPostOptions() {
    return {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }
}

export function getGetOptions() {
    return {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    }
}

export const service = {

    login,

}

const prefix = 'http://127.0.0.1:5000'

function login(username, password) {
    alert(username)
    alert(password)
    const requestOptions = {...getPostOptions(),
        body: JSON.stringify({username, password})}

    return fetch(`${prefix}/manaagiinloginheseg/`, requestOptions).then(handleResponse)
}
